import "./import_to_stock_modal.css";
import react, { useEffect, useMemo, useState } from "react";
import { Label, Upload } from "@mui/icons-material";
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from "@mui/icons-material/Cancel";
import Papa from "papaparse";
import Pagination from "react-js-pagination";
import Tooltip from "@mui/material/Tooltip";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Input, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { add_products_to_stock_by_import } from "../../../../services/stock_service";
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import StoreExistingStock from "./StoreExistingStock ";


const headers_to_be_checked = ["product_code", "category", "product_name", "product_quantity", "product_price", "product_description","supplier", "min_stock", "safety_stock"];
const headers_mandatory = ["product_code", "category", "product_name", "product_quantity", "product_price"];


const columns = [
    { id: 'product_reference', label: "Référence produit", minWidth: 0 },
    { id: 'product_code', label: "Code produit", minWidth: 0 },
    { id: 'product_name', label: "Produit", minWidth: 0 },
    { id: 'category', label: "Famille d'achat", minWidth: 0 },
    { id: 'supplier', label: "Fournisseur", minWidth: 0 },
    { id: 'product_description', label: "Description", minWidth: 0 },
    { id: 'product_quantity', label: "Quantité", minWidth: 0 },
    { id: 'product_price', label: "Prix", minWidth: 0 },
    { id: 'min_stock', label: "Stock min", minWidth: 0 },
    { id: 'safety_stock', label: "Stock de réserve", minWidth: 0 },
    { id: 'stock_status', label: "Statut", minWidth: 0 }
];

function setState(product_exist){
    return(
      <>
        <Tooltip title="" placement="bottom" >
            <span style={{marginLeft:'2%'}}>
                {
                  product_exist==true
                  ?<Button className="status_waiting" >En stock</Button>
                  :<Button className="status_success" >Nouveau</Button>
                }
            </span>
        </Tooltip>
      </>
    );
  }


const Import_to_stock_modal = ({ open_importProducts_to_stock_modal, handleClose_importProducts_to_stock_modal, categories, suppliers, verify_product_by_code_in_stock }) => {

    let user=JSON.parse(localStorage.getItem('user-info'))
    const user_id=user.id;
    const user_role=user.role;

    const config = {delimiter : ";",header:true};
    const [waiting, setWaiting] = useState(false);
    const [import_data, setImport_data] = useState(null);

    const [file_content, setFile_content] = useState(null);

    const [content_per_page, setcontent_per_page] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setdataPerPage] = useState(9);
    const [data_count, setdata_count] = useState(0);

    const [warningText,setwarningText] = useState("");
    const [existing_products,setexisting_products] = useState([]);

    const [errorText, seterrorText] = useState("");
    const [openExistingStockDialog, setOpenExistingStockDialog] = useState(false);
    const [newButExistStock,setNewButExistStock]  = useState([]);

    

    useEffect(() => {
        if (newButExistStock.length > 0) {
            console.log("wawwawwwawawa");
            setTimeout(() => {
                setOpenExistingStockDialog(true);
            }, 500); // Small delay to ensure smooth UI transition
        }
    }, [newButExistStock]);



    useEffect(() => {
        if (existing_products.length && file_content?.length) {
            const updatedData = file_content.map((importedProduct) => {
                const exists = existing_products.some(existing => existing.product_code === importedProduct.product_code);
                return {
                    ...importedProduct,
                    stock_status: exists, // Set stock_status to true if it exists
                };
            });
    
            setFile_content(updatedData); // Update the file_content with the status
            setcontent_per_page(updatedData.slice(dataPerPage * (currentPage - 1), dataPerPage * currentPage)); // Refresh current page content
        }
    }, [existing_products, file_content]);
    


    async function download_model() {
        setWaiting(true);
        const data = [{
            "product_reference": "XXXXXX",
            "product_code": "XXXXXX",
            "supplier":null,
            "category": 1,
            "product_name": "Name",
            "product_description": "",
            "product_quantity": 5,
            "product_price": 100000,
            "min_stock": 2,
            "safety_stock": 3
        }];
        const csvData = Papa.unparse(data, config);
        console.log(csvData);
        const filename = "model.csv";
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setWaiting(false);
    }

    async function download_categories(){
        setWaiting(true);
        let data = [];
        let tmp_json = {};
        console.log(categories);
        for(let category of categories){
            tmp_json = {};
            tmp_json["ID Catégorie"] = category.id_category;
            tmp_json["Catégorie"] = category.name;
            data.push(tmp_json);
        }
        const csvData = Papa.unparse(data,config);
        const filename = "categories.csv";
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setWaiting(false);
    }


    async function download_suppliers(){
        setWaiting(true);
        let data = [];
        let tmp_json = {};
        for(let supplier of suppliers){
            tmp_json = {};
            tmp_json["ID Fournisseur"] = supplier.id;
            tmp_json["Fournisseur"] = supplier.fullName;
            tmp_json["Maison mère"] = supplier.parentCompany;
            data.push(tmp_json);
        }
        const csvData = Papa.unparse(data,config);
        const filename = "fournisseurs.csv";
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setWaiting(false);
    }

    async function import_csv_file(e) {
        setWaiting(true);
        setFile_content([]);
        let file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = async ({ target }) => {
            const csv = await Papa.parse(target.result, {
                header: true,
            });
            const tmp_data = csv?.data;
            const file_header = Object.keys(tmp_data[0]);
            let nonexisting_headers = headers_to_be_checked.filter((elem) => {
                return !file_header.includes(elem);
            });
            console.log(nonexisting_headers);
            let msg_error = "";
            for (let non_existing_column of nonexisting_headers) {
                if (msg_error == "") msg_error += "Colonne inexistante : " + non_existing_column;
                else msg_error += "," + non_existing_column;
            }

            const product_code_counts= {};
            for (let product of tmp_data) {
                const code = product.product_code?.trim(); // Trim in case of spaces
                if (code) {
                    product_code_counts[code] = (product_code_counts[code] || 0) + 1;
                }
            }

            const duplicatedCodes = Object.keys(product_code_counts).filter(code => product_code_counts[code] > 1);
            if (duplicatedCodes.length > 0) {
                if (msg_error !== "") msg_error += " | ";
                msg_error += "Doublons trouvés pour les product_codes : " + duplicatedCodes.join(", ");
            }
            
            seterrorText(msg_error);
            let taken_data = [];
            let data_to_be_taken = true;
            for (let product of tmp_data) {
                data_to_be_taken = true;
                for (let header of headers_mandatory) {
                    if (!product.hasOwnProperty(header)) {
                        data_to_be_taken = false;
                        break;
                    }
                }
                if (data_to_be_taken){
                    taken_data.push(product);
                }
            }

            setcontent_per_page(taken_data.slice(dataPerPage*(currentPage-1), dataPerPage*currentPage));
            console.log("parsedData", taken_data);
            await setFile_content(taken_data);
            await setdata_count(taken_data.length);
            await check_products_codes_existance(taken_data);
            setWaiting(false);
        };
        reader.readAsText(file);
    }


    async function check_products_codes_existance(imported_products) {
        setwarningText("");
        setexisting_products([]);  // Reset existing products list
    
        let products_codes = imported_products.map(product => product.product_code);
        let tmp_existing_prd = await verify_product_by_code_in_stock(products_codes);
    
        if (tmp_existing_prd && tmp_existing_prd.length !== 0) {
            setwarningText("⚠️ Certains produits existent déjà !");
            setexisting_products(tmp_existing_prd);
        }
    
        // Keep all products in file_content so user sees everything
        setFile_content(imported_products);
        setdata_count(imported_products.length);
        setcontent_per_page(imported_products.slice(dataPerPage * (currentPage - 1), dataPerPage * currentPage));
    }
    

    // const associate_imported_product_to_the_existing = useMemo(() => {
    //     let product_exist = false;
    //     let tmp_file_data = [];
    //     let tmp_data = [];
    //     console.log(existing_products,file_content);
    //     if(existing_products && file_content){
    //         tmp_file_data = [...file_content];
    //         tmp_file_data.map((pr_imported,id_pr_imported)=>{
    //             product_exist = false;
    //             tmp_data = [];
    //             existing_products.map((pr)=>{
    //                 if(pr.product_code == pr_imported.product_code){product_exist=true; return;}
    //             });
    //             if(product_exist) tmp_file_data[id_pr_imported]["stock_status"] = true;
    //         })
    //     }
    //     //console.log("tmp_file_data",tmp_file_data);
    //     //setFile_content(tmp_file_data);
    //     console.log("associate",product_exist);
    // },[existing_products])


    async function submit_data() {
        seterrorText("");
    
        if (!file_content || file_content.length === 0) {
            seterrorText("Aucun produit à ajouter !");
            return;
        }
    
        setWaiting(true);
        console.log("Tous les produits importés:", file_content);
    
        // Remove existing products at submission
        const nonExistingProducts = file_content.filter(product => 
            !existing_products.some(existing => existing.product_code === product.product_code)
        );

        const NewExistingProducts = file_content.filter(product => 
            existing_products.some(existing => existing.product_code === product.product_code)
        );
        setNewButExistStock(NewExistingProducts);

        console.log("hado kaynin",NewExistingProducts);

    
        if (nonExistingProducts.length === 0 && NewExistingProducts.length > 0) {
            setOpenExistingStockDialog(true);
            setWaiting(false);
            return;
        }
    
        console.log("Produits à stocker:", nonExistingProducts);
    
        const formData = new FormData();
        formData.append("performed_by", user_id);
       // formData.append("requester_role",user_role);
        formData.append("data", JSON.stringify(nonExistingProducts)); // Send only new products
    
        try {
            const response = await add_products_to_stock_by_import(formData);
            console.log("Produits stockés avec succès:", response.data);
                    if (NewExistingProducts.length === 0) {
                        handleClose_importProducts_to_stock_modal();
                    }


        } catch (error) {
            console.log("Erreur lors de l'ajout:", error.response);
        }
    
        setWaiting(false);
    }
    


    function get_supplier_by_id(id){
        let tmp_supplier="";
        for(let supplier of suppliers){
            if(supplier.id == id){ tmp_supplier=supplier.fullName;break;}
        }
        return tmp_supplier;
    }

    function get_category_by_id(id){
        let tmp_category = "";
        for(let category of categories){
            if(category.id_category == id){ tmp_category=category.name; break;}
        }
        return tmp_category;
    }


    async function change_page(page) {
        setCurrentPage(page);
        console.log(file_content.length);
        setcontent_per_page(file_content.slice(dataPerPage*(page-1), dataPerPage*page));
        console.log(file_content.slice(dataPerPage*(page-1), dataPerPage*page).length);
    }

    const handleDeleteRow = (index) => {
        const updatedContent = [...file_content];
        updatedContent.splice(index, 1);  // Remove item at the specified index
        setFile_content(updatedContent);  // Update the state
        setcontent_per_page(updatedContent.slice(dataPerPage * (currentPage - 1), dataPerPage * currentPage));  // Update pagination
        setdata_count(updatedContent.length);  // Update data count
    };
    


    return (
        <Dialog fullWidth={true} maxWidth={'md'} open={open_importProducts_to_stock_modal} onClose={handleClose_importProducts_to_stock_modal}>
            <DialogTitle>
                Importer le catalogue de vos produits
            </DialogTitle>
            <DialogContent>
                <div className="import_button_container">
                    <div className="button_container">
                        <label htmlFor="csv_file" variant="contained" className="submit_but" startIcon={<Upload className="my_icon" />} >
                            Importer
                            <input type="file" style={{ display: "none" }} accept=".csv" name="csv_file" id="csv_file" onChange={(e) => import_csv_file(e)} />
                        </label>
                    </div>
                    <div style={{display:"flex",marginTop:"5px"}}>
                        <span style={{ textDecoration: "underLine", color: "blue", cursor: "pointer" }} onClick={download_model}>Télécharger le modèle</span>
                        <span style={{margin:"0 5px"}}>/</span>
                        <span style={{ textDecoration: "underLine", color: "blue", cursor: "pointer" }} onClick={download_categories}>Catégories</span>
                        <span style={{margin:"0 5px"}}>/</span>
                        <span style={{ textDecoration: "underLine", color: "blue", cursor: "pointer" }} onClick={download_suppliers}>Fournisseurs</span>
                    </div>
                    </div>
                {
                    content_per_page != null
                        ? <>
                            <div className="import_results_container">
                                <div className="import_results_table_container">
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    {
                                                        columns.map((col, id) => (
                                                            <TableCell key={"header" + col.id}>{col.label}</TableCell>
                                                        ))
                                                    }
                                                    <TableCell>Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    content_per_page.length != 0
                                                        ? <>
                                                            {
                                                                content_per_page.map((product, id) => (
                                                                    <TableRow key={"product" + id}>
                                                                        {
                                                                            columns.map((header, id_header) => (
                                                                                <TableCell key={"product" + id + "_" + header.label}>
                                                                                    {
                                                                                        header.id=="supplier"?get_supplier_by_id(product[header.id])
                                                                                        :header.id=="category"?get_category_by_id(product[header.id])
                                                                                        :header.id=="stock_status"?setState(product[header.id])
                                                                                        :product[header.id]
                                                                                    }
                                                                                </TableCell>
                                                                            ))
                                                                        }
                                                                            <TableCell>
                                                                                    <IconButton color="error" onClick={() => handleDeleteRow(id)}>
                                                                                        <DeleteIcon />
                                                                                    </IconButton>
                                                                                </TableCell>
                                                                    </TableRow>
                                                                ))
                                                            }
                                                        </>
                                                        : <></>
                                                }
                                            </TableBody>

                                        </Table>
                                    </TableContainer>

                                </div>
                                <>
                                    {
                                        content_per_page.length != 0
                                            ? <div className="pagination_container">
                                                <Pagination
                                                    activePage={Number(currentPage)}
                                                    itemsCountPerPage={dataPerPage}
                                                    totalItemsCount={Number(data_count)}
                                                    pageRangeDisplayed={4}
                                                    onChange={change_page.bind(this)}
                                                />
                                            </div>
                                            : <></>
                                    }
                                </>

                            </div>
                        </> : <></>
                }
            </DialogContent>
            <DialogActions>
            <div className="dialogBottom">
                <div className="messages">
                {errorText && (
                    <p className="error-message">{errorText}</p>
                )}
                {warningText && (
                    <p className="warning-message">{warningText}</p>
                )}
                </div>

                <div className="buttons">
                <Button
                    variant="contained"
                    className="submit_but cancel_but"
                    onClick={handleClose_importProducts_to_stock_modal}
                    startIcon={<CancelIcon className="my_icon" />}
                >
                    Annuler
                </Button>
                <Button
                    variant="contained"
                    className="submit_but valide_but"
                    onClick={submit_data}
                    disabled={!!errorText}
                    startIcon={<AddIcon className="my_icon" />}
                >
                    Ajouter
                </Button>
                </div>
            </div>
            </DialogActions>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <StoreExistingStock
                    open={openExistingStockDialog}
                    handleClose={() => setOpenExistingStockDialog(false)}
                    existingProducts={newButExistStock}
                    handleClose_importProducts_to_stock_modal={handleClose_importProducts_to_stock_modal}
                    
                />

        </Dialog>
    )
}

export default Import_to_stock_modal;